import { useQuery } from '@tanstack/react-query';
import { QueryKeys } from '@gokrew/models/constants';
import { getPerformanceSummary } from '@/api/performance';
import { useEmployeePortalAuth } from '@/context/EmployeeAuthContext';

/**
 * Whether the company has Performance switched on (PF-21). The only
 * performance call that never answers 403, so every other performance query
 * waits for it: with the module off nothing else is fetched (a 403 would
 * otherwise send the person back home).
 */
export function usePerformanceSummary() {
  const { user } = useEmployeePortalAuth();

  return useQuery({
    queryKey: [QueryKeys.PerformanceSummary, user?.id],
    queryFn: getPerformanceSummary,
    enabled: !!user,
    staleTime: 5 * 60_000,
  });
}

/** True once the module is known to be on. */
export function usePerformanceEnabled(): boolean {
  const { data } = usePerformanceSummary();
  return !!data?.data.enabled;
}
